import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from '../../configuration/services';
import { TakeawayServices } from '../services';
import { TakeawayOrderSelectPage } from '../takeaway-order-select/takeaway-order-select';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the TpvLoaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-updel',
  templateUrl: 'takeaway-order-updel.html',
})
export class TakeawayOrderUpDelPage {

  update: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public configurationServices: ConfigurationServices,
    public alertCtrl: AlertController,
    public translate: TranslateService) {

    this.takeawayServices.getOrders(this.globals.restaurant_uid, this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID);
    this.update = this.navParams.get('update');
  }

  openModElement(i, j, element) {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('instant-seleccionar-plato-producto'),
      message: this.translate.instant('instant-modificar-plato-producto-seleccionado'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.openModSelect(i, j, element);
          }
        }
      ]
    });
    confirm.present();
  }

  openDelElement(i, j, element) {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('instant-seleccionar-plato-producto'),
      message: this.translate.instant('instant-elminar-plato-producto-seleccionado'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteElement(i, j, element);
          }
        }
      ]
    });
    confirm.present();
  }

  openModSelect(i, j, element) {
    this.takeawayServices.i = i;
    this.takeawayServices.j = j;
    this.takeawayServices.element = element;
    this.takeawayServices.update_state = true;
    this.navCtrl.push(TakeawayOrderSelectPage);
  }

  deleteElement(i, j, element) {
    element.sections[i].list[j].state = 'delete';
    element.sections[i].list[j].finish = '';
    this.takeawayServices.afs.collection('orders').doc(element.UID).update({
      sections: element.sections,
    }).then(async doc => {
      if (element.sections[i].list[j].change != '') {
        this.deleteFromTPV(element.sections[i].list[j].change);
      } else {
        this.deleteFromTPV(element.sections[i].list[j].name);
      }

    });
  }

  one_time: boolean = true;
  deleteFromTPV(name) {
    this.takeawayServices.table_tmp = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index];

    for (let list of this.globals.objectToArray(this.takeawayServices.table_tmp.ticket.list)) {
      if (list.name == name && this.one_time && list.delete == false && list.count == true) {
        list.count = false;
        list.delete = true;
        this.one_time = false;
      }
    }

    this.takeawayServices.afs.collection('tables').doc(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID).update({
      ticket: {
        amount: this.takeawayServices.table_tmp.ticket.amount,
        payment: this.takeawayServices.table_tmp.ticket.payment,
        payment_type: this.takeawayServices.table_tmp.ticket.payment_type,
        date: this.takeawayServices.table_tmp.ticket.date,
        number: this.takeawayServices.table_tmp.ticket.number,
        waiter: this.takeawayServices.table_tmp.ticket.waiter,
        waiter_uid: this.takeawayServices.table_tmp.ticket.waiter_uid,
        list: this.takeawayServices.table_tmp.ticket.list,
        updated_at: new Date(),
        created_at: this.takeawayServices.table_tmp.ticket.created_at,
        tip: this.takeawayServices.table_tmp.ticket.tip || 0,
      },
      state: 'close'
    }).then(async doc => {
      //data set waiter activity
      var extra_activity: any =
      {
        'type': 'cancel',
        'value': 1,
        'source': 'takeaway',

      };
      this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
      this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list))
      this.navCtrl.pop();
    });


  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-updel/takeaway-order-updel.ts